import { useState, useContext } from 'react';
import { Box } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
import { AppContext, SttFormTextarea } from '../../../sporttia/all';

type Props = {
    onSendComment: (text: string) => void;
    onSendPrivateMessage?: () => void;
    senderName?: string;
};

export default function MessageCommentBox({
    onSendComment,
    onSendPrivateMessage,
    senderName,
}: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [text, setText] = useState<string>('');

    function SendButton(): React.ReactElement {
        return (
            <IconButton
                onClick={() => sendComment(text)}
                style={{ color: '#495e0b' }}
            >
                <Typography variant="button">{t('Comment')}&nbsp;</Typography>

                <SendIcon style={{ fontSize: 20 }} />
            </IconButton>
        );
    }

    /**
     * Send comment
     */
    const sendComment = (textToSend: string): void => {
        onSendComment(textToSend);
        setText('');
    };

    // -----| Render |-----
    return (
        <Box ml={8} mb={3}>
            <SttFormTextarea
                grid
                autoFocus
                rows={2}
                defVal={text}
                onChange={({
                    value,
                }: {
                    name: string | undefined;
                    value: unknown;
                }) => setText(value as string)}
                InputProps={{ endAdornment: <SendButton /> }}
            />

            {onSendPrivateMessage &&
                cxt?.logged &&
                cxt?.user &&
                cxt?.user?.role !== cxt?.constants?.roleSC && (
                    <Box mt={1} justifyContent="flex-end">
                        <Link
                            onClick={() => onSendPrivateMessage()}
                            sx={{
                                color: 'var(--brand-text)',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            {t('popup.message.startPrivate')}: {senderName}
                        </Link>
                    </Box>
                )}
        </Box>
    );
}
